import type { ProjectId, AssetId, TimeStreamAsset } from '../schema';
import getStore from '../store';
import getLocalAssetId from '../assetId/getLocalAssetId';
import type { OutlookSpaceAssetId } from 'owa-timestream-types';
import isLocalAssetId from '../assetId/isLocalAssetId';

export default function getAssetOrUndefined(
    projectId: ProjectId,
    assetId: AssetId
): TimeStreamAsset | undefined {
    const projectSummary = getStore().projects.get(projectId);
    if (!projectSummary) {
        return undefined;
    }

    if (!projectSummary.assets.has(assetId) && !isLocalAssetId(assetId)) {
        const localAssetId = getLocalAssetId(assetId as OutlookSpaceAssetId);
        if (localAssetId) {
            assetId = localAssetId;
        }
    }

    const asset = projectSummary.assets.get(assetId);
    if (!asset) {
        return undefined;
    }

    return asset;
}
